import React from "react";

const Footer = () => {
  return (
    <div>
      {/* <hr></hr> */}
      <div className="text-sm mt-10 title flex font-extralight text-gray-400 justify-center items-center py-3">
        Designed & built by Gurjit Singh
      </div>
    </div>
  );
};

export default Footer;
